/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterDto } from '../../models/center-dto';

export interface UserCenterControllerFindByChildId$Params {
  childId: string;
}

export function userCenterControllerFindByChildId(http: HttpClient, rootUrl: string, params: UserCenterControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
  const rb = new RequestBuilder(rootUrl, userCenterControllerFindByChildId.PATH, 'get');
  if (params) {
    rb.path('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterDto>>;
    })
  );
}

userCenterControllerFindByChildId.PATH = '/api/center/user/childId/{childId}';
